import { CityUtil, ModelRow } from "@mcleod/core";
import { TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDriverEventsQuickInfo } from "./autogen/AutogenLayoutDriverEventsQuickInfo";

export class DriverEventsQuickInfo extends AutogenLayoutDriverEventsQuickInfo {
    /** This is an event handler for the onRowDisplay event of tableDriverEvents. */
    tableDriverEventsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow() as TableRow;
        const data = tableRow.data as ModelRow;

        const labelGridCityStateZip = tableRow.findComponentById("textboxCity") as Textbox;
            labelGridCityStateZip.text = CityUtil.formatCityStateZip(data.get("city"), data.get("state"));
    }

}
